import { Link } from 'react-router-dom';
import { articles } from '@/mocks/yihao';

export default function ArticleSection() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">最新资讯</h2>
            <p className="text-foreground-600 text-base">了解壹号娱乐最新动态和行业资讯</p>
          </div>
          <Link
            to="/category/live-casino"
            className="hidden md:flex items-center gap-1.5 text-primary-600 hover:text-primary-700 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer border border-background-200/60 hover:border-primary-200 transition-colors duration-300"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-bold text-base text-foreground-900 mb-2.5 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm line-clamp-2 mb-4">{article.excerpt}</p>
                <div className="flex items-center justify-between">
                  <span className="text-foreground-400 text-xs">{article.date}</span>
                  <span className="text-primary-500 text-xs font-medium flex items-center gap-1">
                    阅读全文 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center md:hidden">
          <Link
            to="/category/live-casino"
            className="inline-flex items-center gap-1.5 text-primary-600 font-medium text-sm whitespace-nowrap cursor-pointer"
          >
            查看全部资讯 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}